/**
 * Custom magic link auth — replaces Magic.link SDK.
 * All auth state is managed via JWT in localStorage.
 */

const AUTH_KEY = 'gtp-riddle_auth';

/**
 * Send a magic link email to the given address.
 */
export async function sendMagicLink(email) {
  const res = await fetch(`${process.env.REACT_APP_SERVER_URL}/auth/send-link`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email }),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Failed to send magic link');
  return data;
}

/**
 * Verify a magic link token and get a JWT back.
 */
export async function verifyMagicLink(token) {
  const res = await fetch(`${process.env.REACT_APP_SERVER_URL}/auth/verify`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ token }),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Invalid or expired link');
  return data;
}

/**
 * Check if user is currently logged in (has a JWT).
 */
export function isLoggedIn() {
  return !!localStorage.getItem(AUTH_KEY);
}

/**
 * Get the stored JWT token.
 */
export function getToken() {
  return localStorage.getItem(AUTH_KEY);
}

/**
 * Store JWT after successful login.
 */
export function setToken(token) {
  localStorage.setItem(AUTH_KEY, token);
}

/**
 * Log out — clear the JWT.
 */
export function logout() {
  localStorage.removeItem(AUTH_KEY);
}
